import React from "react";
import footer from "../assets/footer.png";
export default function LetterFooter() {
  return (
    <div
      className="letter-footer"
      style={{
        justifyContent: "space-around",
        // padding: 15,
        position: "absolute",
        bottom: "0",
        width: "100%",

        // border: "1px solid black",
      }}
    >
      <img src={footer} alt="logo" width="100%" />
    </div>
  );
}
